import { executeLambda } from '@olympeio/core';
import { Brick, registerBrick } from 'olympe';

const timestamp = () => { return new Date().toISOString() };

export default class MacrometaStreamHandler extends Brick {
    
    init($) {
        $.onDestroy(async () => await this.delete_subscription($));
    }
    
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} client
     * @param {string} stream
     * @param {string} subscription
     * @param {string} tag
     * @param {string} handler
     * @param {function(string)} setResults
     */
    update($, [client, stream, subscription, tag, handler], [setResults]) {
        // Write your code here.
        // Check https://olympe.support for documentation.
        // Check https://github.com/olympeio/CORE for examples.
        //
        // This method is executed the first time when all inputs have a value
        // and then anytime an input receives a new value.
        // Override `setupExecution()` to change this behavior.
        console.log("[MACROMETA]:", timestamp(), "MacrometaSubscriber.update()");

        Promise.resolve(this.init_consumer($, client, stream, subscription))
          .then( () => {

            const consumer = $.get('macrometa_consumer');

            consumer.on('open', () => { this.heartbeat($, setResults); });
            consumer.on("close", async () => {
                clearTimeout($.get('message_timeout'));
            });
            consumer.on("error", (err) => {
                console.error("[MACROMETA]:", timestamp(), err);
            });

            consumer.on("message", async (msg) => {
                this.heartbeat($, setResults);
                const { payload, messageId } = JSON.parse(msg);
                const data = Buffer.from(payload, "base64").toString("ascii")
                
                //console.debug("Message:", data);
                const [results] = await executeLambda($, handler, [tag, payload]);
                
                consumer.send(JSON.stringify({ messageId }));
                console.log("[MACROMETA]:", timestamp(), messageId);
                /*
                Promise.resolve(
                    $.runner(handler)
                     .set('message', data)
                     .set('tag', tag)
                     .waitFor('result')
                ).then(result => {
                    consumer.send(JSON.stringify({ messageId }));
                    console.log("[MACROMETA]:", timestamp(), messageId);
                });
                */
            });
            

        });
    }

    async init_consumer($, client, stream, subscription) {
      if (!$.has('macrometa_consumer')) {
        const consumer = await client.createStreamReader(
          stream,
          subscription,
          false,
          false,
          null
        );
        $.set('macrometa_consumer', consumer);
        console.debug("[MACROMETA]:", timestamp(), "Consumer created");
      }
    }

    heartbeat($, setResults) {
      clearTimeout($.get('message_timeout'));

      $.set('message_timeout', setTimeout(() => {
        if ($.has('macrometa_consumer')) {
          const consumer = $.get('macrometa_consumer');
          $.remove('macrometa_consumer');
          consumer.terminate();
          console.debug("[MACROMETA]:", timestamp(), "hearbeat(): connection terminated");
        }
        console.debug("[MACROMETA]:", timestamp(), "heartbeat(): setting results");
        setResults(Date.now());
      }, 60000 + 1000));
    }

    async delete_subscription($) {
        const stream = $.get('stream');
        const subscription = $.get('subscription');
        const client = $.get('client');
        if ($.has('macrometa_consumer')) {
          const consumer = $.get('macrometa_consumer');
          consumer.terminate();
          console.debug("[MACROMETA]:", timestamp(), "destroy(): consumer terminated");
        }
        await client.deleteStreamSubscription(stream, subscription, false);
        console.log(
          "[MACROMETA]:", timestamp(), `${subscription} subscription deleted successfully from stream ${stream}`
        );
      }
}

registerBrick('018ef101e3230d483fdf', MacrometaStreamHandler);
